import { Select } from "antd";
import React, { useState } from "react";
import "./Select.css";

const SelectComp = ({ type, onChange, handleChange, options, value, placeholder, style = {} }) => {

  const handleSelectChange = val => {
    if (onChange) onChange(val);
    if (handleChange) handleChange(val);
  };

  return (
    <div className="SelectComp">
      <Select
        size="large"
        style={{ width: "100%", ...style }}
        mode={type}
        value={value}
        placeholder={placeholder}
        onChange={handleSelectChange}
        options={options}
      />
    </div>
  );
};

export default SelectComp;
